import { format } from 'date-fns';

const formatEventDate = (date) => format(date, 'MMMM d, y');

export { formatEventDate };
